// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._nl8aG3XWwIBhPcOQnI4{align-items:center;min-height:40px;padding:8px 12px 8px 8px}._nl8aG3XWwIBhPcOQnI4.UoSXpESWpHEG6aKTHCwX{padding-left:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectMembersPadding": `_nl8aG3XWwIBhPcOQnI4`,
	"empty": `UoSXpESWpHEG6aKTHCwX`
};
export default ___CSS_LOADER_EXPORT___;
